import React, { FC, useCallback, useMemo } from 'react';

import { Checkbox } from '@rbilabs/components-library/build/components/checkbox';

import { useCdpContext } from 'state/cdp';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { ModifierListItem } from './modifier-list-item';
import { IModifierTypeUIProps } from './types';
import {
  getModifierOptionMultiplier,
  getSingleSelectedOption,
  logProductModifierCustomization,
  transformSelectedOptionToSelections,
} from './utils';

export const ModifierCheckbox: FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const enableModifierAsQuantity = useFlag(LaunchDarklyFlag.ENABLE_MULTIPLIER_AS_QUANTITY);
  const selectedOption = useMemo(() => getSingleSelectedOption(selections), [selections]);
  const isChecked = getModifierOptionMultiplier(selectedOption) === 1;
  const cdp = useCdpContext();
  const handleCheckClick = useCallback(() => {
    const newSelectedOptionMultiplier = isChecked ? 0 : 1;
    const newSelectedOption = modifier.options.find(
      opt => getModifierOptionMultiplier(opt) === newSelectedOptionMultiplier
    );
    if (newSelectedOption) {
      onSelectionsChange(
        transformSelectedOptionToSelections(newSelectedOption, enableModifierAsQuantity)
      );
      logProductModifierCustomization(
        newSelectedOption.name?.locale ?? '',
        modifier.name.locale,
        newSelectedOption._key,
        cdp
      );
    }
  }, [
    isChecked,
    modifier.options,
    modifier.name.locale,
    onSelectionsChange,
    enableModifierAsQuantity,
    cdp,
  ]);

  return (
    <ModifierListItem
      isListItemClickable
      content={modifier}
      selectedOption={selectedOption}
      onListItemClick={handleCheckClick}
      controls={
        <Checkbox
          data-testid="modifier-checkbox-control"
          checked={isChecked}
          label=""
          name={`checkbox-${modifier.name?.locale}`}
        />
      }
    />
  );
};
